import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';


const SettingTab = (): React.ReactElement => {
  const [showAbout, setShowAbout] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const navigate = useNavigate();
  const renderAbout = () => (
    <div className="content about">
      <div className="about-header">
        <button className="back-btn" onClick={() => setShowAbout(false)}>‹ Back</button>
        <h2>About</h2>
      </div>
      <div className="about-content">
        <h3>5sentence.com</h3>
        <p>5sentence.com is a language learning application designed to help users improve their English vocabulary and sentence construction skills.</p>
        
        <h4>Features:</h4>
        <ul>
          <li>Personal vocabulary management</li>
          <li>AI-powered sentence generation</li>
          <li>Text-to-speech functionality</li>
          <li>Spaced repetition learning</li>
        </ul>
        
        <h4>How it works:</h4>
        <p>Add words to your personal vocabulary, and our AI will generate contextual sentences to help you learn and remember them effectively.</p>
        
        <div className="app-info">
          <p><strong>Version:</strong> 1.0.0</p>
          <p><strong>Developer:</strong> 5sentence.com Team</p>
        </div>
      </div>
    </div>
  );

  const renderHelp = () => (
    <div className="content about">
      <div className="about-header">
        <button className="back-btn" onClick={() => setShowHelp(false)}>‹ Back</button>
        <h2>Help</h2>
      </div>
      <div className="about-content">
        <p>Use the tabs below to navigate the application:</p>
        <ul>
          <li><strong>Speak:</strong>Listen to AI-generated sentences from your vocabulary.</li>
          <li><strong>Vocabulary:</strong> manage the words you are learning.</li>
          <li><strong>Setting:</strong> view app information and logout.</li>
        </ul>
        <p>Tap "Next 5 Sentences" in the Speak tab to hear new examples. Use "Add" in the Vocabulary tab to store new words.</p>
      </div>
    </div>
  );

  if (showHelp) {
    return renderHelp();
  }

  if (showAbout) {
    return renderAbout();
  }

  const logout = () => {
    navigate('/logout');
  };

  return (
    <div className="content setting">
      <ul className="settings-list">
        <li className="setting-item" onClick={logout}>
          <span className="setting-text">Logout</span>
          <span className="setting-arrow">›</span>
        </li>
        <li className="setting-item">
          <span className="setting-text">Version</span>
          <span className="setting-value">1.0.0</span>
        </li>
        <li className="setting-item" onClick={() => setShowHelp(true)}>
          <span className="setting-text">Help</span>
          <span className="setting-arrow">›</span>
        </li>
        <li className="setting-item" onClick={() => setShowAbout(true)}>
          <span className="setting-text">About</span>
          <span className="setting-arrow">›</span>
        </li>
      </ul>
    </div>
  );
};

export default SettingTab;
